import React from 'react';
import { motion } from 'framer-motion';
export function Mission() {
  return <section id="mision" className="py-32 relative overflow-hidden" data-id="element-82">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-83" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-84">
        <div className="max-w-4xl mx-auto text-center" data-id="element-85">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-86">
            <span className="text-amber-400 font-semibold tracking-wider uppercase text-sm mb-6 block" data-id="element-87">
              Misión
            </span>
            <h2 className="text-4xl md:text-6xl font-bold text-zinc-100 mb-10 leading-tight" data-id="element-88">
              Ayudando a Principiantes a Construir Ingresos Reales Online
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6 text-lg md:text-xl text-zinc-400 leading-relaxed max-w-3xl mx-auto mb-16" data-id="element-89">
            <p data-id="element-90">
              Después de años aprendiendo y adaptándome a los constantes cambios
              del mundo digital, mi objetivo es claro: compartir mi experiencia
              para ayudar a personas comunes a entender que sí es posible
              construir ingresos online, incluso comenzando desde cero.
            </p>
            <p data-id="element-91">
              A través de disciplina, enfoque y constancia, creo firmemente que
              cualquier persona puede aprender las habilidades necesarias para
              crear un futuro diferente usando internet. No se trata de atajos,
              se trata de construir bases sólidas.
            </p>
          </motion.div>

          {/* Stats Blocks */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-12 border-t border-white/10" data-id="element-92">
            <div className="p-6" data-id="element-93">
              <div className="text-3xl font-bold text-amber-400 mb-2" data-id="element-94">10+</div>
              <div className="text-sm text-zinc-400 uppercase tracking-wider font-medium" data-id="element-95">
                Años de Experiencia
              </div>
            </div>
            <div className="p-6 border-t md:border-t-0 md:border-l border-white/10" data-id="element-96">
              <div className="text-3xl font-bold text-amber-400 mb-2" data-id="element-97">∞</div>
              <div className="text-sm text-zinc-400 uppercase tracking-wider font-medium" data-id="element-98">
                Estrategias Probadas
              </div>
            </div>
            <div className="p-6 border-t md:border-t-0 md:border-l border-white/10" data-id="element-99">
              <div className="text-3xl font-bold text-amber-400 mb-2" data-id="element-100">
                0 a 1
              </div>
              <div className="text-sm text-zinc-400 uppercase tracking-wider font-medium" data-id="element-101">
                Enfoque Práctico
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}